module.exports = __webpack_public_path__ + "img/ic_setting.5e19ac20.svg";